import { render, staticRenderFns } from "./EditNew.vue?vue&type=template&id=1fb3a192&scoped=true&"
import script from "./EditNew.vue?vue&type=script&lang=js&"
export * from "./EditNew.vue?vue&type=script&lang=js&"
import style0 from "./EditNew.vue?vue&type=style&index=0&id=1fb3a192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb3a192",
  null
  
)

export default component.exports